import { render } from "./AdminIcon.vue?vue&type=template&id=1c5ee8f8"
import script from "./AdminIcon.vue?vue&type=script&lang=js"
export * from "./AdminIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__